module.exports = __webpack_public_path__ + "img/scan (9).2ecbe48a.jpg";